import React from 'react';
import {
  StyledSupportServicesContainer,
  StyledSupportServicesHeading,
  StyledSupportServicesIconContainer,
  StyledSupportServicesSubHeading,
  StyledSupportServicesDescription,
  StyledSupportServicesLink,
  StyledSupportServicesButton,
  StyledSupportServicesNumber,
  StyledSupportServicesCloseIcon,
  StyledSupportServicesHeaderContainer,
  StyledSupportServicesOrgName,
  StyledSupportServicesOrgContainer,
  StyledSupportServiceNavigationContainer,
} from './SupportServices.styled';
import { ReactComponent as UrgentHelp } from './UrgentHelp.svg';
import { ReactComponent as CloseIcon } from '../../images/icons/close-white.svg';
import { useNavigate } from 'react-router-dom';
import { getQueryParam } from '../../utils/helper';
import { IMAGES_URL } from '../../constants';
import { StyledSmallLogo } from 'components/PlayerDashboard/PlayerDashboard.styled';

interface ICountry {
  countryName: string;
  orgList: {
    name: string;
    link: string;
    phone?: string;
    linkText: string;
  }[];
}

export const SupportServices: React.FC = () => {
  const navigate = useNavigate();

  const fromPath = getQueryParam('from');


  // return to the specific chapter summary you came from or return to the dash
  // -1 is the equivalent of hitting the back button 
  const goBack = () => {
    document.startViewTransition(() => {
      if (fromPath) {
        navigate(`${fromPath}`);
      } else {
        navigate(-1);
      }
  });
  }

  const countryData: ICountry[] = [
    {
      countryName: 'United Kingdom',
      orgList: [
        { name: 'Childline', link: 'https://www.childline.org.uk', phone: '0811 1111', linkText: 'www.childline.org.uk' },
        { name: 'PAPYRUS', link: 'https://www.papyrus-uk.org', phone: '0800 068 41 41', linkText: 'www.papyrus-uk.org' },
        { name: 'The mix', link: 'https://www.themix.org.uk', linkText: 'www.themix.org.uk' },
      ],
    },
    {
      countryName: "Ireland",
      orgList: [
        {
          name: "CHILDLINE",
          phone: "1800 66 66 66",
          link: "https://www.childline.ie",
          linkText: "www.childline.ie",
        },
        {
          name: "JIGSAW",
          link: "https://www.jigsaw.ie",
          linkText: "www.jigsaw.ie",
        },
        {
          name: "TEXT ABOUT IT",
          phone: "TEXT: 50808",
          link: "https://www.textaboutit.ie",
          linkText: "www.textaboutit.ie",
        },
      ],
    },
    {
      countryName: "Northern Ireland",
      orgList: [
        {
          name: "CHILDLINE",
          phone: "0800 1111",
          link: "https://www.childline.org.uk",
          linkText: "www.childline.org.uk",
        },
        {
          name: "LIFELINE",
          phone: "0808 808 8000",
          link: "https://lifelinehelpline.info",
          linkText: "lifelinehelpline.info",
        },
        {
          name: "MINDING YOUR HEAD",
          link: "https://mindingyourhead.info",
          linkText: "mindingyourhead.info",
        },
        {
          name: "CARA-FRIEND",
          link: "https://cara-friend.org.uk",
          linkText: "cara-friend.org.uk",
        },
      ],
    },
  ]

  return <>
      <StyledSupportServicesHeaderContainer>
        <StyledSupportServiceNavigationContainer>
          <StyledSmallLogo src={`${IMAGES_URL}logo-white.png`} />
          <StyledSupportServicesCloseIcon onClick={() => goBack()}>
            <CloseIcon />
          </StyledSupportServicesCloseIcon>
        </StyledSupportServiceNavigationContainer>
        <StyledSupportServicesIconContainer><UrgentHelp /></StyledSupportServicesIconContainer>
        <StyledSupportServicesHeading text={'Get support'} />
        <StyledSupportServicesDescription>
          Everyone goes through tough times. The key is knowing how and when to get help. 
          <br />
          <br />
          Whether you're an athlete, parent or coach, taking care of yourself and looking out for others is most important.
        </StyledSupportServicesDescription>
      </StyledSupportServicesHeaderContainer>

      {
        countryData.map((country, index) => {
          return (
            <StyledSupportServicesContainer columnNumber={index}>
              <StyledSupportServicesSubHeading text={country.countryName}/>
              <StyledSupportServicesDescription>
                The following organisations provide support and further resources on mental health.
                <br />
                <br />
                If a person is in crisis or life is in danger, call emergency services.
              </StyledSupportServicesDescription>
              {country.orgList.map((org) => {
                return (
                  <StyledSupportServicesOrgContainer>
                    <StyledSupportServicesOrgName text={org.name}/>
                    {org.phone ? <StyledSupportServicesNumber>{org.phone}</StyledSupportServicesNumber> : null}
                    <StyledSupportServicesLink><a onClick={ () => window.open(org.link, '_blank')?.focus() }>{org.linkText}</a></StyledSupportServicesLink>
                  </StyledSupportServicesOrgContainer>
                )  
              })}
            </StyledSupportServicesContainer>
          )
        })
      }

        <StyledSupportServicesButton label={ fromPath ? 'Close' : 'Return Home'} onClick={() => goBack()} />
      
  </>
}